<template>
    <kiosk-team-details :teamId="props.teamId">
        <div class="vx-col-span-12 lg:vx-col-span-10 vx-flex vx-flex-col vx-w-full vx-justify-center">
            <page-header>Sub Teams</page-header>

            <kiosk-teams-controls
                v-model="fetchParams"
                :sortingEnabled="false"
                @reset="resetFilters"
                @apply="applyFilters"
                class="vx-mb-6"
            >
            </kiosk-teams-controls>

            <page-loading v-if="loading && !list.length"></page-loading>

            <vx-box
                v-else-if="!list.length && !isEqual(defaultFilters(), fetchParams)"
                color="info"
                class="vx-flex vx-flex-col vx-px-8 vx-py-20 vx-gap-6 vx-items-center vx-text-xl vx-text-slate-500"
            >
                <div class="vx-w-64 vx-mx-auto vx-text-center">
                    No results for current search, try adjusting your filters.
                </div>
                <vx-button type="button" color="secondary" @click="resetFilters">
                    Reset All <font-awesome-icon :icon="faCircleX" />
                </vx-button>
            </vx-box>

            <div v-else-if="list.length">
                <kiosk-teams-table>
                    <kiosk-team-row v-for="(row, index) in list" v-model="list[index]" :key="row.id"></kiosk-team-row>
                </kiosk-teams-table>

                <div class="vx-mt-8 vx-flex vx-justify-between vx-w-full vx-gap-10">
                    <vx-button
                        v-if="fetchParams.cursor"
                        @click="loadData()"
                        color="muted-dark"
                        size="xl"
                        class="vx-grow-0"
                        data-test="load-more-btn"
                        :loading="loading"
                    >
                        Load More
                        <font-awesome-icon :icon="faSpinner"></font-awesome-icon>
                    </vx-button>
                </div>
            </div>

            <vx-box
                v-else
                color="info"
                class="vx-mt-4 vx-flex vx-flex-col vx-px-8 vx-py-20 vx-gap-6 vx-items-center vx-text-xl vx-text-slate-500"
            >
                No sub teams yet.
            </vx-box>
        </div>
    </kiosk-team-details>
</template>

<script setup>
import KioskTeamDetails from './KioskTeamDetails.vue';
import { faCircleX, faSpinner } from '@fortawesome/pro-solid-svg-icons';
import { VxBox, VxButton } from '@voxie/frontend-components';
import KioskTeamRow from './KioskTeamRow.vue';
import KioskTeamsControls from './KioskTeamsControls.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import KioskTeamsTable from './KioskTeamsTable.vue';
import PageHeader from '../../general/PageHeader.vue';
import PageLoading from '../../general/PageLoading.vue';
import adminTeamsClient from '~/services/adminTeamsClient';
import { useCursorPagination } from '~/composables/useCursorPagination';
import { isEqual } from '~/utils/helpers';

const props = defineProps({
    teamId: {
        type: Number,
        required: true,
    },
});

const defaultFilters = () => ({
    query: '',
    cursor: null,
});

const { loading, list, fetchParams, fetchRecords } = useCursorPagination();

const resetFilters = () => {
    fetchParams.value = defaultFilters();
    loadData();
};

const applyFilters = () => {
    fetchParams.value = {
        ...fetchParams.value,
        cursor: null,
    };

    loadData();
};

const loadData = () => {
    fetchRecords(adminTeamsClient.listSubTeams(props.teamId, fetchParams.value));
};

resetFilters();
</script>
